import { Button } from '@latitude/button';
import type { RefObject } from 'react';
import { useRef } from 'react';
import type { DayProps } from 'react-day-picker';
import { useDayRender } from 'react-day-picker';

export const Day = (dayProps: DayProps) => {
  const buttonRef = useRef<HTMLButtonElement>(null);
  const dayRender = useDayRender(
    dayProps.date,
    dayProps.displayMonth,
    // react-day-picker's types still expect React 18's non-nullable
    // RefObject<T>; R19's RefObject<T | null> is the equivalent shape.
    buttonRef as RefObject<HTMLButtonElement>,
  );
  if (dayRender.isHidden) {
    return <div role="gridcell" />;
  }
  if (!dayRender.isButton) {
    return <div {...dayRender.divProps} />;
  }

  return (
    <Button
      ref={buttonRef}
      htmlType="button"
      variant="strong"
      type="ghost"
      size="small"
      rawProps={{
        name: 'day',
      }}
      {...dayRender.buttonProps}
    />
  );
};
